var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrasparency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 192 192",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    gradientUnits: "userSpaceOnUse",
    x1: 51.497,
    x2: 140.503,
    y1: 120.764,
    y2: 31.757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34cdfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d9f1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_21-reliable",
    "data-name": "21-reliable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168 16c-21.482 0-58.006-5.32-66.343-13.657a8 8 0 0 0 -11.314 0c-8.337 8.337-44.861 13.657-66.343 13.657a8 8 0 0 0 -8 8v88c0 10.776 12.25 20.08 33.9 35.6 15.174 10.868 38.1 27.3 38.1 36.4a8 8 0 0 0 16 0c0-9.1 22.926-25.532 38.1-36.4 21.65-15.52 33.9-24.824 33.9-35.6v-88a8 8 0 0 0 -8-8z",
    fill: "#e6f9fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.9 139.6c-21.65-15.52-33.9-24.824-33.9-35.6v-88a8.052 8.052 0 0 1 .161-1.6 210.6 210.6 0 0 1 -24.161 1.6 8 8 0 0 0 -8 8v88c0 10.776 12.25 20.08 33.9 35.6 15.174 10.868 38.1 27.3 38.1 36.4a8 8 0 0 0 16 0c0-4.265 5.031-10.136 11.939-16.292-7.263-8.922-22.78-20.046-34.039-28.108z",
    fill: "#ccf2fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.836 38.611c-5.871-.617-11.609-1.4-17.054-2.343-11.821-2.039-21.191-4.574-28.645-7.751a8 8 0 0 0 -6.274 0c-7.454 3.177-16.824 5.712-28.644 7.751-5.446.938-11.184 1.726-17.055 2.343a8 8 0 0 0 -7.164 7.956v59.386a8 8 0 0 0 2.6 5.9c4.942 4.523 14.384 11.29 21.283 16.234 9.249 6.628 18.814 13.481 26.833 20.536a8 8 0 0 0 10.568 0c8.019-7.055 17.584-13.908 26.838-20.54 6.894-4.94 16.336-11.707 21.278-16.23a8 8 0 0 0 2.6-5.9v-59.386a8 8 0 0 0 -7.164-7.956z",
    fill: "url(#New_Gradient_Swatch_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 112a7.962 7.962 0 0 1 -4.432-1.344l-24-16 8.875-13.312 17.9 11.931 27.41-34.275 12.494 10-32 40a7.991 7.991 0 0 1 -6.247 3z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrasparency);
export default __webpack_public_path__ + "static/media/trasparency.d509ef0bcc6bdd9bd1be6cd2e0dd24d1.svg";
export { ForwardRef as ReactComponent };